import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";

import {
    Breadcrumb,
    Dropdown,
    Icon,
    Menu,
    Row,
    Table,
    Modal,
    Col,
    Button,
    message,
    Select,
    AutoComplete,
    Input,
} from "antd";

import Text from "antd/lib/typography/Text";

import Loader from "components/Loader/Loader";

import { fetchCohortDetailApi, searchCohortApi, updateCohortApi, exportCohortApi } from "utils/apiService";
import { Link } from "react-router-dom";

const { Option } = AutoComplete;

const SurveyResponses = (props) => {
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);

    const [cohortUserList, setCohortUserList] = useState({
        cohortName: "",
        cohortUsers: [],
        pageSize: 50,
        pageNum: 1,
        totalPages: 1,
        cohorttype: "",
    });

    const [searchUserList, setSearchUserList] = useState([]);

    const [importModal, setImportModal] = useState(false);
    const addCohortUser = useRef([]);

    const [deleteModal, setDeleteModal] = useState(false);
    const deleteCohortUser = useRef([]);

    const { cohortID } = useParams();

    const loadTable = () => {
        setTableLoading(true);
        fetchCohortDetailApi({
            requestData: {
                uuid: cohortID,
                page: cohortUserList.pageNum,
            },
            resCallback: () => {
                loading && setLoading(false);
                setTableLoading(false);
            },
            res200Callback: (res) => {
                setCohortUserList({
                    ...cohortUserList,
                    cohortUsers: res.data.customer_list,
                    cohortName: res.data.name,
                    totalPages: res.data.total_pages,
                    cohorttype: res.data.cohort_type,
                });
            },
            resErrorCallback: () => {
                props.history.go(-1);
            },
        });
    };

    useEffect(() => {
        loadTable();
    }, [cohortUserList.pageNum]);

    const searchCohort = (str) => {
        searchCohortApi({
            requestData: {
                uuid: cohortID,
                search_key: str,
            },
            res200Callback: (res) => {
                setSearchUserList(res.data.search_results.map((ele) => ({ ...ele, key: ele.contact_number })));
            },
        });
    };
    const ExportCohort = () => {
        message.loading("Exporting Cohort ...", 1);
        exportCohortApi({
            requestData: {
                uuid: cohortID,
                start_date: null,
                end_date: null,
            },
            res200Callback: () => {
                message.success("Cohort Exported successfully.", 1);
            },
            resErrorCallback: () => {
                message.error("Exporting the Cohort List was unsuccessful!", 1);
            },
        });
    };

    const columns = [
        {
            title: "Phone Number",
            dataIndex: "contact_number",
            key: "contactNumber",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        whiteSpace: "nowrap",
                    }}>
                    {data || "XXXXXXXXX"}
                </Text>
            ),
        },
        {
            title: "Customer Name",
            dataIndex: "name",
            key: "customerName",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        whiteSpace: "nowrap",
                    }}>
                    {data || "XXXXXXXXX"}
                </Text>
            ),
        },
        {
            title: "Banat Al Nujoom  Card No.",
            dataIndex: "card_number",
            key: "rewardCardNumber",
            render: (rewardCardNumber) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "bold",
                        color: "#181818",
                    }}>
                    {rewardCardNumber || "XXXXXXXX"}
                </Text>
            ),
        },
        {
            title: "Nationality",
            dataIndex: "nationality",
            key: "nationality",
        },
        {
            title: "",
            dataIndex: "contact_number",
            key: "uuid",
            render: (uuid) => {
                return (
                    <div style={{ width: "16px" }}>
                        {/* <Dropdown
							placement={"bottomLeft"}
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ marginLeft: "0" }}
							overlay={
								<Menu>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											deleteCohortUser.current = [uuid];
											setDeleteModal(true);
										}}>
										<Text style={{ color: "#F5222D" }}>Remove</Text>
									</Menu.Item>
								</Menu>
							}>
							<Icon
								type="more"
								onClick={(e) => {
									e.stopPropagation();
								}}
								style={{ fontSize: "16px", color: "#747474", marginLeft: "52px" }}
							/>
						</Dropdown> */}

                        <Icon
                            type='delete'
                            style={{ color: "red", fontSize: "18px", opacity: "0.6" ,marginLeft: "52px" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                deleteCohortUser.current = [uuid];
                                setDeleteModal(true);
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const renderOption = (item) => {
        return (
            <Option key={item.contact_number} value={item.contact_number}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#181818",
                        }}>
                        {item.name}
                    </Text>
                    <Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "12px", lineHeight: "18px" }}>
                        {item.contact_number}
                    </Text>
                </div>
            </Option>
        );
    };

    return loading ? (
        <Row type='flex' align='middle' justify='center' style={{ marginTop: "200px" }}>
            <Loader />
        </Row>
    ) : (
        <>
            <Row
                style={{
                    width: "100%",
                    padding: "40px 25px 70px",
                    margin: "60px auto 20px",
                    backgroundColor: "#FAFAFA",
                }}
                gutter={[12, 48]}>
                <Row type='flex' justify='space-between' align='top'>
                    <div>
                        <Text
                            style={{
                                color: "#181818",
                                /*fontFamily: "Gotham",*/ fontStyle: "normal",
                                fontWeight: "bold",
                                fontSize: "24px",
                                lineHeight: "39px",
                            }}>
                            {cohortUserList.cohortName || "..."}
                        </Text>
                        <Breadcrumb
                            style={{ margin: "12px 0" }}
                            separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
                            <Breadcrumb.Item
                                style={{
                                    /*fontFamily: "Gotham",*/ fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    color: "#747474",
                                }}>
                                <Link to={"/cohorts"}>Cohort Management</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                style={{
                                    /*fontFamily: "Gotham",*/ fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    color: "#464646",
                                }}>
                                {cohortUserList.cohortName || "..."}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                        <AutoComplete
                            dropdownStyle={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
                            size='large'
                            style={{ width: 250 }}
                            onSearch={(str) => {
                                str.length >= 2 && searchCohort(str);
                            }}
                            onSelect={(v) => {
                                deleteCohortUser.current = [v];
                                setDeleteModal(true);
                            }}
                            optionLabelProp='value'
                            dataSource={searchUserList.map(renderOption)}
                            placeholder='Search Customer'>
                            <Input
                                style={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
                                suffix={<Icon type='search' />}
                            />
                        </AutoComplete>
                        {cohortUserList.cohorttype === "CO" && (
                            <Button
                                style={{
                                    background: "#FFFFFF",
                                    color: "#181818",
                                    border: "1px solid #E8E8E8",
                                    margin: "0 0 0 16px",
                                    borderRadius: "4px",
                                    height: "40px",
                                    padding: "8px 16px 8px 16px",
                                    fontSize: 16,
                                }}
                                onClick={() => setImportModal(true)}>
                                <Icon type='plus' />
                                Add Customers
                            </Button>
                        )}
                        {/* <Button
                            onClick={() => ExportCohort()}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 16px",
                                color: "#FFFFFF",
                                fontSize: "16px",
                                lineHeight: "24px",
                                background: "#fec708",
                                borderRadius: "5px",
                                height: "100%",
                                margin: "0 0 0 16px",
                            }}>
                            <Icon
                                type='export'
                                style={{
                                    height: "16px",
                                }}
                            />
                            Export Report
                        </Button> */}
                    </div>
                </Row>
                <Table
                    columns={columns}
                    dataSource={cohortUserList.cohortUsers}
                    pagination={{
                        pageSize: cohortUserList.pageSize,
                        current: cohortUserList.pageNum,
                        total: cohortUserList.pageSize * cohortUserList.totalPages,
                    }}
                    onChange={(pagination) => setCohortUserList({ ...cohortUserList, pageNum: pagination.current })}
                    loading={tableLoading}
                />
            </Row>
            <Modal
                centered
                visible={importModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setImportModal(false)}
                footer={null}>
                <Row className='modal-row'>
                    <Row>
                        <Icon
                            type='usergroup-add'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Add New Customers
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                        <div>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    // fontWeight:"bold"
                                }}>
                                Customer Phone Numbers
                            </Text>
                            <Select
                                mode='tags'
                                className='time-value-cohort-col-main-element'
                                style={{ width: "100%", marginTop: "8px" }}
                                placeholder='Eg. - 552980118'
                                tokenSeparators={[",", " "]}
                                onChange={(e) => {
                                    if (
                                        (e?.length !== 0 &&
                                            JSON.parse(localStorage.getItem("countryData"))?.short_name === "AE" &&
                                            e[e?.length - 1]?.length === 12) ||
                                        (JSON.parse(localStorage.getItem("countryData"))?.short_name === "IN" &&
                                            e[e?.length - 1]?.length === 12)
                                    ) {
                                        addCohortUser.current = e;
                                    } else {
                                        message.info("Incorrect contact number");
                                    }
                                }}
                            />
                        </div>
                        <Row
                            type='flex'
                            justify='end'
                            align='middle'
                            style={{
                                marginTop: "24px",
                            }}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    boxShadow: "none",
                                    borderRadius: "5px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    color: "#181818",
                                    marginRight: "12px",
                                }}
                                onClick={() => setImportModal(false)}>
                                Cancel
                            </Button>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "5px",
                                    border: "none",
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    setTableLoading(true);
                                    updateCohortApi({
                                        requestData: {
                                            action: "add",
                                            uuid: cohortID,
                                            customer_list: addCohortUser.current,
                                        },
                                        resCallback: () => {
                                            setTableLoading(false);
                                        },
                                        res200Callback: () => {
                                            message.success("Cohort Updated successfully.");
                                            loadTable();
                                            setImportModal(false);
                                        },
                                    });
                                }}>
                                Add Customers
                            </Button>
                        </Row>
                    </Row>
                </Row>
            </Modal>
            <Modal
                centered
                visible={deleteModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => setDeleteModal(false)}
                footer={null}>
                <Row className='modal-row'>
                    <Row>
                        <Icon
                            type='delete'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            Remove item
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                        <Col span={24}>
                            <Text>Are you sure you want to remove this user from the cohort?</Text>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={18}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    boxShadow: "none",
                                    borderRadius: "20px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    color: "#181818",
                                }}
                                onClick={() => setDeleteModal(false)}>
                                Cancel
                            </Button>
                        </Col>
                        <Col
                            style={{
                                marginTop: "60px",
                                textAlign: "right",
                            }}
                            span={6}>
                            <Button
                                size='large'
                                style={{
                                    height: "40px",
                                    borderRadius: "2px",
                                    border: "none",
                                    backgroundColor: "#C91713",
                                    color: "#FFFFFF",
                                }}
                                onClick={() => {
                                    setTableLoading(true);
                                    updateCohortApi({
                                        requestData: {
                                            action: "delete",
                                            uuid: cohortID,
                                            customer_list: deleteCohortUser.current,
                                        },
                                        resCallback: () => {
                                            setTableLoading(false);
                                        },
                                        res200Callback: () => {
                                            setDeleteModal(false);
                                            loadTable();
                                        },
                                    });
                                }}>
                                Remove
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Modal>
        </>
    );
};

export default SurveyResponses;
